import * as React from "react";

function SvgSearchThin(props) {
  return <svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><circle cx={15} cy={15} r={8.5} stroke="currentColor" /><path fill="currentColor" stroke="currentColor" strokeWidth={0.5} d="M21.27 20.92l4.18 4.18-.35.36-4.19-4.19z" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/search-thin_514aea.svg";
export { SvgSearchThin as ReactComponent };